import { Role } from 'constants/roles';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { DateTimePicker } from 'shared/mui/DatePicker/DateTimePicker/DateTimePicker';
import { DeleteIconButton } from 'shared/mui/IconButtons';
import { AutocompleteInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { User } from 'types/embedded/user';

import { StyledBox } from './UserEntityPermissionsDialogForm.styled';

type Props = {
  id?: number;
  index: number;
  onRemoveField: (index: number) => void;
};

export const UserEntityPermissionsDialogFormPermission: React.FC<Props> = ({
  id,
  index,
  onRemoveField,
}) => {
  const translate = useTypedTranslate();
  const { control } = useFormContext();

  return (
    <StyledBox>
      <ReferenceInput
        filter={{ 'roleEntities.alias': [Role.Tech], enabled: true }}
        perPage={50}
        reference="users"
        source={`permissions.${index}.user`}
      >
        <AutocompleteInput
          disabled={!!id}
          filterToQuery={(searchText: string) => ({ fullName: searchText })}
          fullWidth
          helperText={false}
          label={translate('app.merchants.responsiblePerson')}
          optionText={(record: User) => record && `${record.firstName} ${record.lastName}`}
          size="small"
          variant="outlined"
        />
      </ReferenceInput>
      <Controller
        control={control}
        name={`permissions.${index}.expiredAt`}
        render={({ field }) => (
          <DateTimePicker
            disabled={!!id}
            label={translate('app.merchants.accessExpirationDate')}
            minDate={Date.now()}
            onChange={(date) => {
              field.onChange(date);
            }}
            value={field.value}
          />
        )}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
        <DeleteIconButton onClick={() => onRemoveField(index)} />
      </Box>
    </StyledBox>
  );
};
